/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import SmallPopupWithBulltePoint from "../CommonSmallPopupWithBulletPoint";
import { GlobalConfiguration } from "../../../utils/configurationProvider";

const MAX_LENGTH = 150;

const RecreatePromptModalPopup = ({
  onConfirmBtnClick,
  onCancelBtnClick,
  customDeclineReason,
  loadingBox,
  inputDisabled,
}) => {
  const [declineRecreateReason, setRecreateDeclineReason] = useState(
    customDeclineReason ?? "Recreate this transaction.",
  );

  const handleInputChange = (event) => {
    let value = event.target.value;

    value = value.replace(/[^a-zA-Z0-9\s]/g, "");
    value = value.replace(/\s+/g, " ");
    value = value.replace(/^\s/, "");
    value = value.slice(0, MAX_LENGTH);

    setRecreateDeclineReason(value);
  };

  const isValidReason = declineRecreateReason.replace(/\s+/g, "").length >= 10;

  const handleClick = () => {
    if (!isValidReason) return;
    onConfirmBtnClick(declineRecreateReason);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && isValidReason && !inputDisabled) {
        handleClick();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [declineRecreateReason, inputDisabled]);

  const [isFocused, setIsFocused] = useState(false);
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-z-index-loader">
      <SmallPopupWithBulltePoint
        headerTitle="Send for recreation"
        bulletPoints={[
          "Transaction must be recreated as approval is not possible",
          "To recreate this transaction, you must reject it first. This will remove it from the pending list and move it to the recreate transaction dashboard",
        ]}
        isTextInputField={true}
        inputPlaceholder="Reason (10-150 char)"
        inputVariant={computeVariant(declineRecreateReason, isFocused)}
        inputOnFocus={(e) => setIsFocused(true)}
        inputOnBlur={(e) => setIsFocused(false)}
        inputAdornment=""
        inputValue={declineRecreateReason}
        inputOnInput={handleInputChange}
        inputIsDisabled={inputDisabled}
        inputFgColor="var(--text-primary)"
        inputIsFullWidth={true}
        noteText={false}
        btnOneText="Cancel"
        btnOneHandleFunction={onCancelBtnClick}
        btnOneEnabledBgColor="transparent"
        btnOneOutLineColor="var(--text-primary)"
        btnOneIsDisabled={false}
        btnOneEnabledTextColor="var(--text-primary)"
        btnTwoText="Reject"
        btnTwoHandleFunction={handleClick}
        btnTwoInActiveVariantNeeded={true}
        btnTwoIsDisabled={!isValidReason}
        btnTwoEnabledBgColor={
          !isValidReason ? "var(--text-disabled)" : "var(--failed)"
        }
        btnTwoEnabledTextColor="var(--text-primary)"
        btnTwoIsLoaderNeeded={loadingBox}
        inputBgColor="var(--primary-bg)"
      />
    </div>
  );
};

export default RecreatePromptModalPopup;
